import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import {Objects} from "components";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

export default class HighScores extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Scores_Highs._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.filterDate = moment().format();
	}

	fetchData = async (state) => {
		this.state.limit = 15;
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.id = this.props.id ?? null;
		this.state.filter.isDaily = this.props.isDaily ?? false;
		this.state.filter.filterDate = this.state.filterDate;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns =
			[
				{
					Header: "User",
					accessor: "user_name",
				},
				{
					Header: "Timestamp",
					id: "created",
					accessor: obj => (moment(obj.created).local().format('MM/DD/YYYY h:mm A'))
				},
				{
					Header: "Score",
					accessor: "score",
				},
			]
		return (
			<div className={'box-body'}>
				<div className={'table-bar'}>
					<div className={"row rbc-toolbar"}>
						<div>
							<IconButton onClick={async () => {
								this.setState({filterDate: moment(this.state.filterDate).subtract(1, 'day').format()}, async () => {
									await this.fetchData();
								})
							}}><LeftArrowIcon/></IconButton>
							<button className="rbc-today" type="button" onClick={async () => {
								this.setState({filterDate: moment(Date.now()).format()}, async () => {
									await this.fetchData();
								})
							}}>Today
							</button>
							<IconButton onClick={async () => {
								this.setState({filterDate: moment(this.state.filterDate).add(1, 'day').format()}, async () => {
									await this.fetchData();
								})
							}}><RightArrowIcon/></IconButton>
						</div>
						<div className={"rbc-toolbar-label"}>
							<label onClick={() => {
								this.handleToggleModal('showDate')
							}}>
								{moment(this.state.filterDate).format('dddd MMM D')}
							</label>
						</div>
					</div>
				</div>
				<Card>
					<CardContent>
						<ReactTable
							key={this.state.key}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={limit}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: 'ranking'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
